import { Component } from '@angular/core';

@Component({
    selector: 'app-page-loader',
    imports: [],
    templateUrl: './page-loader.component.html',
    styleUrl: './page-loader.component.css'
})
export class PageLoaderComponent {

}
